export const APPLE_APP_STORE_URL = 'https://apps.apple.com/app/id1459492568';
export const GOOGLE_PLAY_URL =
    'https://play.google.com/store/apps/details?id=com.mustad.equinetapp';
